import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';


const Footer = ({ className = "" }) => {
  return (
    <footer className={`border-t border-border bg-card mt-16 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Help Section */}
        <div className="text-center mb-8">
          <h3 className="text-xl font-semibold text-foreground mb-3">
            Need Help?
          </h3>
          <p className="text-muted-foreground mb-6">
            Our support team is here to help you get started
          </p>
          
          {/* Support Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            <Button 
              variant="livechat" 
              size="default" 
              iconName="MessageCircle"
              iconPosition="left"
              className="min-w-[150px]"
            >
              Live Chat
            </Button>
            <Button 
              variant="callsupport" 
              size="default" 
              iconName="Phone"
              iconPosition="left"
              className="min-w-[150px]"
              onClick={() => window.open('tel:8449781051', '_self')}
            >
              Call Support
            </Button>
          </div>

          {/* Contact Information */}
          <div className="text-sm text-muted-foreground">
            <p>Questions? Contact us at</p>
            <p className="font-medium text-foreground">
              <a 
                href="mailto:support@leadgenproai.us" 
                className="hover:underline"
              >
                support@leadgenproai.us
              </a>
            </p>
            <p>
              or call{' '}
              <a 
                href="tel:8449781051" 
                className="font-medium text-foreground hover:underline"
              >
                (844) 978-1051
              </a>
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            {/* Footer Links */}
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              <Link 
                to="/terms-of-service" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Terms of Service
              </Link>
              <Link 
                to="/privacy-policy" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/security" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Security
              </Link>
            </div>
            
            {/* Copyright */}
            <div className="text-sm text-muted-foreground">
              © 2025 LeadGen Pro. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;